module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/step3_reports-b94a68654c8c2f8fc7004e0d829776ec.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/step3_reports.svg
// module id = 1601
// module chunks = 0